(function() {
  function injectKlarna() {
    document.querySelectorAll('klarna-placement').forEach(function(el) {
      if (el.dataset.customDone) return;
      var shadow = el.shadowRoot;
      if (!shadow) return;
      var msg = shadow.querySelector('[part="osm-message"]') || shadow.querySelector('p');
      if (!msg || !msg.textContent) return;
var match = msg.textContent.match(/(\d+[.,]?\d*\s*(?:€|£|\$|kr|CHF|zł|Kč|RON|Ft|kn|лв|USD|EUR|GBP|SEK|NOK|DKK|CHF|PLN|CZK))/i);      if (!match) return;
      var custom = document.createElement('div');
      custom.className = 'klarna-custom';
      custom.innerHTML = '<span>Effectuez 3 paiements de <strong>' + match[1] + '</strong></span>' +
  '<img src="https://x.klarnacdn.net/payment-method/assets/badges/generic/klarna.svg" alt="Klarna">';
      el.parentNode.insertBefore(custom, el.nextSibling);
      el.dataset.customDone = '1';
    });
  }
  var attempts = 0;
  var interval = setInterval(function() {
    injectKlarna();
    attempts++;
    if (attempts > 20) clearInterval(interval);
  }, 500);
})();